import { type AxiosPromise, type AxiosRequestConfig } from 'axios';

import { request as swRequest } from '@wf/sw-ui-kit';

import { LPCO_SERVER } from '../../config';

export function request<T>({ url = '', baseURL = LPCO_SERVER, ...rest }: AxiosRequestConfig): AxiosPromise<T> {
  return swRequest({ baseURL, url, ...rest });
}
